import { z } from 'zod';
/** Workspace roles (productspec §4). */
export const workspaceRoleSchema = z.enum(['owner', 'admin', 'member', 'guest']);
/** Access levels on a page (productspec §4). Ordered from most to least. */
export const pageAccessLevelSchema = z.enum(['full', 'edit', 'comment', 'view']);
/** Identity providers we support (productspec §3). */
export const authProviderSchema = z.enum(['email', 'google']);
/**
 * Actions a user can attempt on a page. The single authorisation function is
 * `can(user, page, action)` (productspec §4).
 */
export const pageActionSchema = z.enum(['view', 'comment', 'edit', 'full']);
/** Who a share is granted to (productspec §3). */
export const sharePrincipalTypeSchema = z.enum(['user', 'email', 'workspace', 'public']);
/**
 * Access levels ordered strongest-first, so a level can be compared against a
 * required level: `levelSatisfies('edit', 'comment')` is true.
 */
const LEVEL_ORDER = { full: 4, edit: 3, comment: 2, view: 1 };
export function levelSatisfies(actual, required) {
    return LEVEL_ORDER[actual] >= LEVEL_ORDER[required];
}
/** Default access a workspace role gets on pages without an explicit share. */
export function defaultLevelForRole(role) {
    switch (role) {
        case 'owner':
        case 'admin':
            return 'full';
        case 'member':
            return 'edit';
        case 'guest':
            // Guests only see what was shared with them explicitly (productspec §4).
            return null;
    }
}
//# sourceMappingURL=auth.js.map